<div *ngIf="!!product && !!price">
  <div class="row">
    <div class="col-1 d-flex align-items-center justify-content-center">
      <button class="btn btn-light delete-button" (click)="removeRow()"><i class="fas fa-times"></i></button>
    </div>
    <div class="col-1 d-flex flex-column justify-content-center">
      <img
        class="img-fluid cart-item-image"
        src="https://cdn1.gung.io/fit-in/100x100/filters:fill(white):background_color(white):format(jpeg)/{{
          product.extra.images[0].s3Uri
        }}"
        alt=""
      />
    </div>
    <div class="col d-flex flex-column justify-content-center">
      <div class="product-name">
        <b>{{ product.id }}</b> - {{ product.name }}
      </div>
    </div>
    <div class="col-1 d-flex flex-column justify-content-center">
      <div class="product-name">{{ product.extra.ar.artbeskrspec }}</div>
    </div>
    <div class="col-2 d-flex align-items-center justify-content-center">
      <lib-buy-btn [id]="data.productId"></lib-buy-btn>
    </div>
    <div class="col-2 d-flex align-items-center justify-content-center flex-column">
      <div>
        <b>
          {{ price.cartRowUnitPrice.value | gungCurrency: price.cartRowUnitPrice.currencyCode:'symbol-narrow':'1.2-2' }}
          <span *ngIf="price.cartRowDiscountPercent !== 0">(-{{ price.cartRowDiscountPercent }}%)</span>
        </b>
      </div>
    </div>
    <div class="vhr col-2 d-flex align-items-center justify-content-center flex-column">
      <div>
        <b>
          <span>
            {{
              price.cartRowTotalPriceInclRowDiscount.value
                | gungCurrency: price.cartRowTotalPriceInclRowDiscount.currencyCode
            }}
          </span>
        </b>
      </div>
    </div>
  </div>
  <div class="row hr"></div>
</div>
